import React from "react";

function SiteDown() {
    return (
        <div style={{
            minHeight: "100vh", display: "flex",
            alignItems: "center", justifyContent: "center",
            padding: "2rem", background: "#fff",
        }}>
            <div style={{ maxWidth: "400px", width: "100%", textAlign: "center" }}>

                <div style={{
                    width: "52px", height: "52px", borderRadius: "50%",
                    border: "1px solid #f7c1c1", display: "flex",
                    alignItems: "center", justifyContent: "center", margin: "0 auto 1.75rem",
                    background: "#FCEBEB",
                }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#A32D2D" strokeWidth="1.6">
                        <circle cx="12" cy="12" r="10" />
                        <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
                    </svg>
                </div>

                <h1 style={{ fontSize: "20px", fontWeight: 500, color: "#111", margin: "0 0 0.5rem" }}>
                    System unavailable
                </h1>
                <p style={{ fontSize: "15px", color: "#666", margin: "0 0 2rem", lineHeight: 1.7 }}>
                    Please contact the Administrator.
                </p>

            </div>
        </div>
    );
}

export default SiteDown;